(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-responsive-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bw-responsive-film')){
    customElements.define('bw-responsive-film',class extends HTMLElement{
      connectedCallback(){
        if(this.abort)return;
        this.abort=new AbortController();
        const options={signal:this.abort.signal};
        this.videos=Array.from(this.querySelectorAll('video'));
        this.button=this.querySelector('[data-play]');
        this.started=new Set();
        requestAnimationFrame(()=>{if(this.dataset.autoplay!=='true')this.revealPoster();});
        this.button.addEventListener('click',()=>{const video=this.current();if(video){this.revealPoster();video.muted=false;video.play().catch(()=>{});}},options);
        this.videos.forEach(video=>{
          video.addEventListener('play',()=>{
            this.started.add(video);this.button.hidden=true;
            document.querySelectorAll('bw-responsive-film video, bw-ritual-film video').forEach(other=>{if(other!==video)other.pause();});
          },options);
          video.addEventListener('pause',()=>{if(video===this.current())this.button.hidden=false;},options);
          video.addEventListener('ended',()=>{if(video===this.current()){this.button.hidden=false;if(this.closest('.bw-reset')){this.revealPoster();video.load();this.started.delete(video);}}},options);
        });
        if('IntersectionObserver' in window){
          this.observer=new IntersectionObserver(entries=>{
            entries.forEach(entry=>{
              this.inView=entry.isIntersecting;
              if(!this.inView)this.videos.forEach(video=>video.pause());
              else this.maybePlay();
            });
          },{threshold:.35});this.observer.observe(this);
        }
        if ('IntersectionObserver' in window) {
          this.posterObserver = new IntersectionObserver(entries => {
            this.posterNear = entries.some(entry => entry.isIntersecting);
            if (this.posterNear) this.revealPoster();
          }, { rootMargin: '160px 0px', threshold: 0 });
          this.posterObserver.observe(this);
        } else {
          this.posterNear = true;
          this.revealPoster();
        }
        this.media=matchMedia('(max-width:749px)');
        this.media.addEventListener('change',()=>{this.videos.forEach(video=>video.pause());this.button.hidden=false;if(this.posterNear)this.revealPoster();this.maybePlay();},options);
      }
      current(){return this.videos.find(video=>video.getClientRects().length);}
      revealPoster(){
        const video = this.current();
        if (!video?.dataset.poster) return;
        const mobile = matchMedia('(max-width:749px)').matches;
        const poster = mobile ? video.dataset.mobilePoster : video.dataset.poster;
        if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
      }
      maybePlay(){
        const video=this.current();
        if(matchMedia('(max-width:749px)').matches||!video||!this.inView||this.dataset.autoplay!=='true'||this.started.has(video)||matchMedia('(prefers-reduced-motion:reduce)').matches||navigator.connection?.saveData)return;
        this.revealPoster();this.started.add(video);video.muted=true;video.play().catch(()=>{this.button.hidden=false;});
      }
      disconnectedCallback(){this.posterObserver?.disconnect();this.observer?.disconnect();this.abort?.abort();this.abort=null;}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-restock-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-restock-request')) {
    customElements.define('bw-restock-request', class extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-restock-body]');
        if (!this.body || typeof subscribe !== 'function') return;
        const ids = JSON.parse(this.dataset.variantIds || '[]').map(String);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const variant = data?.variant;
          if (!variant || !ids.includes(String(variant.id))) return;
          this.body.hidden = Boolean(variant.available);
          this.querySelector('[data-restock-option]').textContent = variant.title;
          this.querySelector('[data-restock-variant]').value = variant.id;
          this.querySelector('[data-restock-title]').value = variant.title;
          this.querySelector('[data-restock-sku]').value = variant.sku || '';
        });
      }
      disconnectedCallback() { this.unsubscribe?.(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
